import PropTypes from "prop-types";
import { FormControl } from "components/template";
import { Select } from "components/atoms";

const SelectControl = ({
  errors,
  value,
  label,
  labelProps,
  orientation,
  options,
  showErrors,
  selectProps: { className: selectClass, ...selectProps } ,
  ...props
}) => {
  return (
    <FormControl
      errors={errors}
      label={label}
      labelProps={labelProps}
      orientation={orientation}
      showErrors={showErrors}
      {...props}
    >
      <Select 
        value={value}
        options={options}
        {...selectProps}
      />
    </FormControl>
  );
};

SelectControl.propTypes = {
  errors: PropTypes.object,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  labelProps: PropTypes.object,
  orientacion: PropTypes.oneOf(["horizontal", "vertical"]),
  options: PropTypes.array,
  selectProps: PropTypes.object,
  showErrors: PropTypes.bool
};

SelectControl.defaultProps = {
  errors: null,
  label: null,
  labelProps: {},
  orientacion: "horizontal",
  options: [],
  selectProps: {},
  showErrors: true 
};

export default SelectControl;
